import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

const CookieConsentBanner = () => {
  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept"
      cookieName="szakacsvisuals-cookie-consent"
      style={{
        background: "#3E3E3E",
        padding: "1rem",
        alignItems: "center",
        fontSize: "14px",
        fontFamily: "Montserrat, sans-serif"
      }}
      buttonStyle={{
        background: "#FFFFFF",
        color: "#3E3E3E",
        fontSize: "14px",
        padding: "10px 20px",
        borderRadius: "4px",
        fontFamily: "Montserrat, sans-serif",
        fontWeight: "500",
        border: "none",
        cursor: "pointer"
      }}
      expires={150}
    >
      This website uses cookies to enhance the user experience.{" "}
      <Link to="/privacy" style={{ color: "#FFFFFF", textDecoration: "underline" }}>
        Learn more about our cookie policy
      </Link>
    </CookieConsent>
  );
};

export default CookieConsentBanner; 